__turbopack_context__.v({
  "chip": "LoadingSpinner-module__EYAwuG__chip",
  "container": "LoadingSpinner-module__EYAwuG__container",
  "fadeOut": "LoadingSpinner-module__EYAwuG__fadeOut",
  "solid": "LoadingSpinner-module__EYAwuG__solid",
  "spin": "LoadingSpinner-module__EYAwuG__spin",
  "spinner": "LoadingSpinner-module__EYAwuG__spinner",
  "tinted": "LoadingSpinner-module__EYAwuG__tinted",
  "title": "LoadingSpinner-module__EYAwuG__title",
});
